import Vue from 'vue';
import AppImage from './AppImage';

Vue.component('app-image', AppImage);



// WEBPACK FOOTER //
// ./src/components/index.js